import React from "react"
import Layout from "../components/layout"
import Helmet from "react-helmet"

import SEO from "../components/seo"
import PrivacyContent from "../components/legal/privacy-content"
import LegalCover from "../components/legal/legal-cover.js"

const Privacy = () => {
  return (
    <Layout>
      <SEO title="Privacy Policy - Credit 101" keywords={[`credit`, `card`, `score`, `build`]} description="We believe privacy is a basic human right. Your personal data is always yours and should never be shared without your permission. At Credit 101, we work to protect the privacy of our visitors."/>
      <Helmet>
        <meta name="robots" content="noindex"/>
      </Helmet>
      <LegalCover title="Privacy Policy"></LegalCover>
      <PrivacyContent></PrivacyContent>
    </Layout>
  )
}

export default Privacy
